export const informacionBasicaState = {
    cargo: '',
    cargo_nombre: '',
    miembro: '',
    dni: '',
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    nombre_completo: '',
    genero: '',
    existe: false,
    fecha_emision: null,
    codigo_verificacion: '',
    isLoading: false,
    isValidated: false,
    message: '',
    severity: '',
    token: '',
}